<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailJiLuList"
      data-title="操作记录"
    >
      <el-segmented
        v-model="state.params.status"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[
          { Text: '全部' },
          { Key: 1, Text: '嘉宾' },
          { Key: 2, Text: '参会人' },
        ]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />

        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="车型" label2="车牌号" />
          </template>
          <template #default="{ row }">
            <text>{{ row.name }}</text>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="类型" label2="核载人数" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              value1="2222222@qq.com"
              value2="安徽省合肥市庐阳区长江东路1256号金华大厦1楼056商铺"
            />
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="司机信息"
              label2="所属公司"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              value1="南方医科大学血液病研究院"
              value2="血液病研究院副院长、白血病诊疗中心主任"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="intro"
          label="说明"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="接送任务" align="center">
          <template #default="{ row }">
            <strong
              class="text-green-700 cursor-pointer hover:underline"
              @click="
                $openMenu({
                  path: 'HuiYiDetailRiChengDetail',
                  title: '日程详情-' + row.number,
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              {{ row.rc }}
            </strong>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {},
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      state.tableData = [
        {
          id: 1,
          name: "报道注册",
          sj: "10:00 ~ 12:00",
          ri: "2025-12-21",
          lx: "报到",
          hc: "主会场",
          jd: "金鳞大酒店",
          dt: "1楼-大厅",
          sm: "需保障 AI 互动展区搭建与多会场直播，做好腾讯高管及海外嘉宾的 VIP 分级接待与多语言服务，分区域规划动线避免拥堵",
          rc: 6,
          qyrc: 1,
          yxqd: 1,
        },
        {
          id: 2,
          name: "报道注册",
          sj: "10:00 ~ 12:00",
          ri: "2025-12-21",
          lx: "报到",
          hc: "主会场",
          jd: "金鳞大酒店",
          dt: "1楼-大厅",
          sm: "需保障 AI 互动展区搭建与多会场直播，做好腾讯高管及海外嘉宾的 VIP 分级接待与多语言服务，分区域规划动线避免拥堵",
          rc: 6,
          qyrc: 1,
          yxqd: 1,
        },
        {
          id: 3,
          name: "报道注册",
          sj: "10:00 ~ 12:00",
          ri: "2025-12-21",
          lx: "报到",
          hc: "主会场",
          jd: "金鳞大酒店",
          dt: "1楼-大厅",
          sm: "需保障 AI 互动展区搭建与多会场直播，做好腾讯高管及海外嘉宾的 VIP 分级接待与多语言服务，分区域规划动线避免拥堵",
          rc: 6,
          qyrc: 1,
          yxqd: 1,
        },
        {
          id: 4,
          name: "报道注册",
          sj: "10:00 ~ 12:00",
          ri: "2025-12-21",
          lx: "报到",
          hc: "主会场",
          jd: "金鳞大酒店",
          dt: "1楼-大厅",
          sm: "需保障 AI 互动展区搭建与多会场直播，做好腾讯高管及海外嘉宾的 VIP 分级接待与多语言服务，分区域规划动线避免拥堵",
          rc: 6,
          qyrc: 1,
          yxqd: 1,
        },
      ];

      // admin_page(state.params).then((res) => {
      //   if (res.status == 200) {
      //     const { list, count } = res.data?.data;
      //     state.tableData = list;
      //     state.totalCount = count;
      //   }
      // });
    };

    return { state, onLoad };
  },
};
</script>

<style lang="scss" scoped></style>
